import KeyValueMap from './_key-value-map.js'
import MarketLayout from './_market-layout.js'

export default {
  name: 'MarketLayoutDescriptors',
  values: {
    categories: {
      configSet: KeyValueMap,
      configValues: {
        TEAM: {
          selectionsHeaderContent: 'participant',
          selectionTypes: [
            'H',
            'A',
          ],
        },
        TEAM_HDA: {
          selectionTypes: [
            '1',
            'X',
            '2',
          ],
        },
        TEAM_HA: {
          selectionTypes: [
            '1',
            '2',
          ],
        },
        PARTICIPANT: {
          selectionTypes: [
            'P1',
            'P2',
          ],
        },
        OVER_UNDER: {
          selectionsHeaderContent: 'type',
          selectionTypes: [
            'O',
            'U',
          ],
        },
        OVER_EXACTLY_UNDER: {
          selectionTypes: [
            'O',
            'TOU',
            'U',
          ],
        },
        DOUBLE_CHANCE: {
          selectionsHeaderContent: 'type',
          selectionTypes: [
            '1X',
            '12',
            'X2',
          ],
        },
        HALF_TIME_FULL_TIME: {
          selectionTypes: [
            '1',
            'X',
            '2',
          ],
        },
        YES_NO: {
          selectionTypes: [
            'Y',
            'N',
          ],
        },
        ODD_EVEN: {
          selectionTypes: [
            'O',
            'E',
          ],
        },
      },
    },
    types: {
      configSet: KeyValueMap,
      configValues: {},
    },
    sportSpecificCategories: {
      configSet: KeyValueMap,
      configValues: {
        esports: {
          PARTICIPANT: {
            selectionNameDisplay: 'show short',
          },
          TEAM_HDA: {
            selectionNameDisplay: 'show short',
          },
        },
      },
    },
    default: {
      configSet: MarketLayout,
      configValues: {},
    },
    selectionHeaders: {
      configSet: KeyValueMap,
      configValues: {
        '12': '$GENERIC_MARKET_CONTENT.SELECTION_HEADER.12',
        O: '$GENERIC_MARKET_CONTENT.SELECTION_HEADER.OVER',
        U: '$GENERIC_MARKET_CONTENT.SELECTION_HEADER.UNDER',
        Y: '$GENERIC_MARKET_CONTENT.SELECTION_HEADER.Y',
        N: '$GENERIC_MARKET_CONTENT.SELECTION_HEADER.N',
        '1X': '$GENERIC_MARKET_CONTENT.SELECTION_HEADER.1X',
        X2: '$GENERIC_MARKET_CONTENT.SELECTION_HEADER.X2',
        X: '$GENERIC_MARKET_CONTENT.SELECTION_HEADER.DRAW',
      },
    },
  },
  meta: {
    extendable: false,
  },
}
